import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import { Defaults } from 'webapp/services/account';

interface Args {
	showBigLogo: boolean;
}

export default class TopbarLogoImageComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;

	get companyName(): string {
		return this.accountService.shownCompanyName;
	}

	get isDummy() {
		return !this.accountService.whiteLabelingLoaded;
	}

	get isCustom() {
		return this.accountService.isCustomAppLogo;
	}

	get showAsImage() {
		return this.isDummy || this.isCustom;
	}

	get logoImageSrc() {
		return this.isDummy ? Defaults.DUMMY_LOGO_LIGHT : this.accountService.appLogo;
	}

	get showCompanyName() {
		// to show title next to small whitelabeled image
		return this.args.showBigLogo && this.isCustom;
	}

	get logoColor() {
		return this.accountService.isClient
			? this.accountService.currentSpace?.color || ''
			: '#4D71F1'; // --databox-brand-500
	}

	get databoxTextOnlyImageSrc() {
		const postfix = this.navigationService.theme.isDark ? '-white' : '';
		return `https://cdn1.databox.com/images/logo/databox-textonly-w-padding${postfix}.svg`;
	}
	<template>
		{{#if this.showAsImage}}
			<img src={{this.logoImageSrc}} width="30" height="30" alt={{this.companyName}} />
			{{#if this.showCompanyName}}
				<span>{{this.companyName}}</span>
			{{/if}}
		{{else}}
			{{#if @showBigLogo}}
				<img
					src={{this.databoxTextOnlyImageSrc}}
					class="text-only-dbx-logo"
					width="130"
					height="28"
					alt="Databox"
				/>
			{{/if}}
			<CommonUiIconComponent @name="DataboxLogo" @size="xl" @fill={{this.logoColor}} />
		{{/if}}
	</template>
}
